import { styled } from "@mui/material/styles";
import { DrawerContextProvider } from "contexts/DrawerContext";
import { SnackbarContextProvider } from "contexts/SnackbarContext";
import type { FC, PropsWithChildren } from "react";

export const DefaultMain = styled("main")(({ theme }) => ({
	padding: "24px 40px",
	display: "flex",
	flexDirection: "column",
	flexGrow: 1,
	backgroundColor: theme.palette.common.black,
	height: "100vh",
	overflow: "hidden",
}));

export const DefaultLayout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<DefaultMain>
			<SnackbarContextProvider>
				<DrawerContextProvider>
					{children}
					{/* <ActionBar />*/}
				</DrawerContextProvider>
			</SnackbarContextProvider>
		</DefaultMain>
	);
};
